import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Home } from './pages/Home';
interface AppProps {
  defaultLanguage?: 'en' | 'es';
  showTrustBar?: boolean;
  showProcessSteps?: boolean;
}
export function App({
  defaultLanguage = 'en',
  showTrustBar = true,
  showProcessSteps = true
}: AppProps) {
  return <LanguageProvider initialLang={defaultLanguage} data-id="element-0" data-mp="3fb17hlv1iddh">
      <Home showTrustBar={showTrustBar} showProcessSteps={showProcessSteps} data-id="element-1" data-mp="2rknkwav856qa" />
    </LanguageProvider>;
}